import { ENV_DEV } from "../../../utils/window";

/**
 * Check for CSS variable value
 * @param {MainClassProps} main
 * @param {String} input
 * @returns {String}
 */
const checkCSSVariable = (main, input) => {
  if (input.startsWith("--")) {
    const value = main.computedStyle.getPropertyValue(input).trim();

    if (ENV_DEV && !value) {
      console.warn(
        `[TorusKit warn]: No \`${input}\` CSS variable found!`
      );
    }

    return value;
  }

  return input;
}

export default checkCSSVariable;